export default __webpack_public_path__ + "static/media/WStore_Icon_Curacao.e00f2a8f.png";